
import Vue, { PropType } from 'vue';

// Types and services
import { ImportMode } from '../modals/ProfileImportModal.vue';

// Components
import Button from '~/components/builders/Base/Button.vue';

// Assets
import LinkedInLogo from '~/assets/img/LlnkedinSquare.svg';
import LinkedInReverseLogo from '~/assets/img/LlnkedinSquareReverse.svg';

// Types
type Variant = 'outline-primary' | 'text-secondary' | 'secondary';
type ImportType = 'linkedin' | 'cv-file';

export default Vue.extend({
    name: 'ImportButton',
    components: { Button },
    props: {
        variant: {
            type: String as PropType<Variant>,
            default: 'outline-primary' as Variant,
        },
        tiny: Boolean,
        onlySourceName: Boolean,
        logo: {
            type: Boolean,
            default: true,
        },
        importType: {
            type: String as PropType<ImportType>,
            default: 'linkedin' as ImportType,
        },
    },
    data() {
        return {
            LinkedInLogo,
            LinkedInReverseLogo,
        };
    },
    methods: {
        openProfileImportDialog() {
            const event = new CustomEvent('profileimport:modal:show', {
                detail: this.importType == 'linkedin' ? ImportMode.EnterId : ImportMode.FileInput,
            });
            window.dispatchEvent(event);
        },
    },
});
